import { z } from 'zod/v4';
import { ActionResourceSchema } from './action-resource.js';

export const ListActionsQuerySchema = z.object({
  count: z
    .preprocess(
      val => val ?? undefined,
      z.coerce.number().int().min(1).optional(),
    )
    .default(10),
  page: z
    .preprocess(
      val => val ?? undefined,
      z.coerce.number().int().min(0).optional(),
    )
    .default(0),
  sort: z.string().optional(),
  filter: z
    .string()
    .max(512)
    .optional()
    .describe(
      'JSON string with filter criteria for corrective and preventive actions',
    ),
  quickFilter: z
    .enum(['all', 'internal', 'external', 'assignedToMe', 'reportedByMe'])
    .optional()
    .default('all')
    .describe(
      "Quick filter options: 'all' for all accessible actions, 'internal' for actions owned by your company, 'external' for actions owned by other companies, 'assignedToMe' for actions assigned to you, 'reportedByMe' for actions where you are the reporter",
    ),
});

export const ListActionsResponseSchema = z.object({
  data: z.array(ActionResourceSchema),
  meta: z.object({
    count: z.number(),
    page: z.number(),
    pageSize: z.number(),
    totalCount: z.number(),
  }),
});

export type ListActionsQuery = z.infer<typeof ListActionsQuerySchema>;
export type ListActionsResponse = z.infer<typeof ListActionsResponseSchema>;
